import { styled } from "@mui/material";
import { StyledWhiteButton } from "./white-button";

export const StyledIconButton = styled(StyledWhiteButton)(({ theme }) => ({
  padding: theme.spacing(1.5),
  minWidth: "unset",
}));